export default "<h3>January 11, 2022</h3>\r\n<p>Version 2.81 fixes an issue which could prevent connection to online multiplayer.</p>";